interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  structuredData?: Record<string, unknown>;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleTags?: string[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  structuredData,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  articleTags,
}: SEOHeadProps) {
  const fullTitle = title.includes('51网址导航') ? title : `${title} - 51网址导航`;
  const baseUrl = 'https://www.51nav.com';
  const fullCanonical = canonicalUrl.startsWith('http') ? canonicalUrl : `${baseUrl}${canonicalUrl}`;
  const fullOgImage = ogImage || `${baseUrl}/og-default.jpg`;

  const ogData = {
    title: fullTitle,
    description,
    url: fullCanonical,
    type: ogType,
    image: fullOgImage,
    siteName: '51网址导航',
    locale: 'zh_CN',
  };

  const lastMod = articleModifiedTime || new Date().toISOString().split('T')[0];

  const allStructuredData: Record<string, unknown>[] = [];

  if (structuredData) {
    allStructuredData.push(structuredData);
  }

  const isArticle = ogType === 'article';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      <meta name="last-modified" content={lastMod} />

      <meta property="og:title" content={ogData.title} />
      <meta property="og:description" content={ogData.description} />
      <meta property="og:url" content={ogData.url} />
      <meta property="og:type" content={ogData.type} />
      <meta property="og:image" content={ogData.image} />
      <meta property="og:site_name" content={ogData.siteName} />
      <meta property="og:locale" content={ogData.locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogData.title} />
      <meta name="twitter:description" content={ogData.description} />
      <meta name="twitter:image" content={ogData.image} />

      <meta name="geo.region" content="CN-BJ" />
      <meta name="geo.placename" content="北京市" />
      <meta name="geo.position" content="39.9042;116.4074" />

      {isArticle && articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {isArticle && articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}
      {isArticle && articleAuthor && (
        <meta property="article:author" content={articleAuthor} />
      )}
      {isArticle &&
        articleTags &&
        articleTags.map((tag) => (
          <meta key={tag} property="article:tag" content={tag} />
        ))}

      {allStructuredData.map((data, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </>
  );
}